export default __webpack_public_path__ + "static/media/icon-perfil.e19f2ef9.svg";